// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1808":"css/admin-app.7069","5502":"css/app.7069"}[chunkId] + ".css";
};